import React from 'react';
import { Home, Shield, Bird, Droplets, Wrench, Eye, Wind } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Home,
      title: "Maçonnerie de façade",
      description: "Retrait des maçonneries non adhérentes, restructuration et mise en peinture. Résultat garanti 10 ans.",
      image: "https://customer-assets.emergentagent.com/job_hauteur-pro-1/artifacts/7goszu6o_F1854026-EC72-4C98-9C73-AA409EF64689.JPG"
    },
    {
      icon: Shield,
      title: "Mise en sécurité",
      description: "Installation de filets pare-gravats sur bâtiments endommagés pour une protection optimale.",
      image: "https://customer-assets.emergentagent.com/job_hauteur-pro-1/artifacts/87wm5hnp_pose%20de%20filet%202.jpg"
    },
    {
      icon: Bird,
      title: "Système anti-volatiles",
      description: "Installation de dispositifs anti-volatiles pour prévenir toutes nuisances.",
      image: "https://images.unsplash.com/photo-1674558346850-7cbd4025ecff"
    },
    {
      icon: Droplets,
      title: "Nettoyage de vitres",
      description: "Nettoyage simple ou remise en état des vitres avec produits professionnels adaptés.",
      image: "https://customer-assets.emergentagent.com/job_hauteur-pro-1/artifacts/w3yzotdq_nettoyage%20de%20vitres.jpg"
    },
    {
      icon: Wind,
      title: "Nettoyage de façades",
      description: "Nettoyage professionnel de façades à haute pression pour un résultat impeccable.",
      image: "https://customer-assets.emergentagent.com/job_hauteur-pro-1/artifacts/umsrbxq6_NETTOYAGE%20KARCHER.jpg"
    },
    {
      icon: Wrench,
      title: "Descentes d'eau pluviale",
      description: "Remplacement des descentes d'eau pluviales en fonte ou PVC.",
      image: "https://customer-assets.emergentagent.com/job_hauteur-pro-1/artifacts/3h0xy7kz_descente%20d%27eau%20pluviale.jpg"
    },
    {
      icon: Eye,
      title: "Inspection de toiture",
      description: "Inspection complète et changement de tuiles pour garantir l'étanchéité.",
      image: "https://images.unsplash.com/photo-1632759145351-1d592919f522"
    },
    {
      icon: Droplets,
      title: "Nettoyage de gouttières",
      description: "Nettoyage et entretien des gouttières pour éviter la mauvaise évacuation des eaux pluviales.",
      image: "https://customer-assets.emergentagent.com/job_hauteur-pro-1/artifacts/593qfhrx_chenaux%20encombr%C3%A9s.jpg"
    },
    {
      icon: Home,
      title: "Assistance bâtiment",
      description: "Aide et support aux entreprises du bâtiment pour tous travaux d'accès difficile.",
      image: "https://images.pexels.com/photos/29946966/pexels-photo-29946966.jpeg"
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-blue-700 font-semibold text-sm uppercase tracking-wider">Nos expertises</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mt-4 mb-6">
            Des solutions complètes pour tous vos travaux en hauteur
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Nos cordistes certifiés interviennent sur tous types de chantiers avec professionnalisme et sécurité
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            // Special handling for "Mise en sécurité" to show full image
            const isSecurityService = service.title === "Mise en sécurité";
            return (
              <div 
                key={index}
                className="group bg-white rounded-xl border border-slate-200 overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <div className={`relative h-48 overflow-hidden ${isSecurityService ? 'bg-slate-100' : ''}`}>
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className={`w-full h-full ${isSecurityService ? 'object-contain' : 'object-cover'} group-hover:scale-110 transition-transform duration-300`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 bg-blue-700 p-3 rounded-lg">
                    <Icon className="text-white" size={24} />
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-slate-900 mb-3">{service.title}</h3>
                  <p className="text-slate-600 leading-relaxed">{service.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;